module.exports = __webpack_public_path__ + "static/media/welcomeBg_responsive.70599445.jpg";